import React, { forwardRef } from 'react'
import styled from 'styled-components'

const Switch = styled.label`
    margin: 0;
    position: relative;
    display: inline-block;
    width: ${(p) => p.width}px;
    height: ${(p) => p.height}px;
`

const Slider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 34px;

    &:before {
        position: absolute;
        content: '';
        height: ${(p) => p.height}px;
        width: ${(p) => p.height}px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 50%;
    }
`

const Input = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + ${Slider} {
        background-color: ${(p) => p.color};
    }

    &:focus + ${Slider} {
        box-shadow: 0 0 1px ${(p) => p.color};
    }

    &:checked + ${Slider}:before {
        transform: translateX(${(p) => p.translateX}px);
    }
`

const SwitchButton = forwardRef(
    (
        { id, width, height, color, name, checked, className, ...otherProps },
        ref
    ) => {
        const calculateMaxTranslateX =
            ((width - 8) / (height - 8)) * (height - 8) - (height - 8)

        return (
            <Switch
                id={`switchBackground${name}`}
                height={height}
                width={width}
                className={className}
                {...otherProps}
            >
                <Input
                    ref={ref}
                    id={id}
                    name={name}
                    color={color}
                    checked={checked}
                    translateX={calculateMaxTranslateX}
                    type="checkbox"
                />
                <Slider height={height - 8} id={`switchSlider${name}`} />
            </Switch>
        )
    }
)
SwitchButton.displayName = 'SwitchButtonx'

export default SwitchButton
